import { render, staticRenderFns } from "./AppToolbar.vue?vue&type=template&id=45fa0ac7&scoped=true&"
import script from "./AppToolbar.vue?vue&type=script&lang=ts&"
export * from "./AppToolbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fa0ac7",
  null
  
)

export default component.exports